import { fetcher } from "../fetch-data/lib/fetcher";
import useSWR from "swr";
import { useMemo } from "react";

const buildEndpoint = (baseUrl, locationKey, source, isAnnual) => {
  if (!locationKey || !source) return null;
  const path = isAnnual ? "annual_development" : "monthly_development";
  return `${baseUrl}/${path}?location_key=${locationKey}&source=${source}`;
};

const getInclusiveEndDate = (endDate, isAnnual) => {
  const adjusted = new Date(endDate);
  if (isAnnual) {
    adjusted.setMonth(11);
    adjusted.setDate(31);
  } else {
    adjusted.setMonth(adjusted.getMonth() + 1);
    adjusted.setDate(0); // letzter Tag des Monats
  }
  adjusted.setHours(23, 59, 59, 999);
  return adjusted;
};

const transformEnergyData = (data, isAnnual, startDate, endDate) => {
  const safe = (val) => val ?? 0;
  const adjustedEndDate = getInclusiveEndDate(endDate, isAnnual);

  return data
    .filter((item) => {
      const dateStr = isAnnual ? `${item.year}-01` : item.month;
      const itemDate = dateStr ? new Date(dateStr) : null;
      return itemDate && itemDate >= startDate && itemDate <= adjustedEndDate;
    })
    .reduce(
      (acc, entry) => {
        acc.labels.push(isAnnual ? entry.year : entry.month);
        acc.values.push(safe(entry.growth));
        acc.tooltipPowerAddition.push(safe(entry.power_addition));
        acc.tooltipPowerReduction.push(safe(entry.power_reduction));
        acc.tooltipCountAddition.push(safe(entry.count_addition));
        acc.tooltipCountReduction.push(safe(entry.count_reduction));
        return acc;
      },
      {
        labels: [],
        values: [],
        tooltipPowerAddition: [],
        tooltipPowerReduction: [],
        tooltipCountAddition: [],
        tooltipCountReduction: [],
      }
    );
};

export const useEnergyAdditionData = (params) => {
  const baseUrl = process.env.REACT_APP_API_BASE_URI;

  // Standardwerte, falls keine gültigen Daten vorhanden
  const {
    locationKey = null,
    source = null,
    isAnnual = true,
    startDate = null,
    endDate = null,
  } = params || {};

  const endpoint = buildEndpoint(baseUrl, locationKey, source, isAnnual);

  const { data, error, isLoading } = useSWR(endpoint, fetcher);

  const transformed = useMemo(() => {
    if (!Array.isArray(data) || !startDate || !endDate) {
      return {
        labels: [],
        values: [],
        tooltipPowerAddition: [],
        tooltipPowerReduction: [],
        tooltipCountAddition: [],
        tooltipCountReduction: [],
      };
    }
    return transformEnergyData(data, isAnnual, startDate, endDate);
  }, [data, isAnnual, startDate, endDate]);

  return {
    ...transformed,
    loading: isLoading,
    error,
  };
};
